<h1 mat-dialog-title>Mapa localização cliente</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 800px;">
    <div class="row mt-1">
        <div class="col-sm">
            <agm-map [latitude]="data.latitude" [longitude]="data.longitude" [zoom]="15"
                (mapReady)="onMapReady($event)">
                <agm-marker [latitude]="data.latitude" [longitude]="data.longitude"></agm-marker>
            </agm-map>
        </div>
    </div>


    <div class="row">
        <div class="col-sm">
            <mat-divider></mat-divider>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm text-right">
            <button mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>clear</mat-icon> Fechar
            </button>
        </div>
    </div>
</div>